import React, { useState } from 'react';
import cn from 'classnames';
import { useSwipeable } from 'react-swipeable';
import Dots from '@wix/da-ds/pkg/pagination/Dots';
import { Props as SubscriptionCenterProps } from '../../SubscriptionCenter';
import IncomeChartPanel from '../ChartPanel/presets/IncomeChartPanel';
import SubscribersChartPanel from '../ChartPanel/presets/SubscribersChartPanel';
import SubscriptionTips from '../../../SubscriptionTips/SubscriptionTips';
import useTiersModuleCounts from '../../../SubscriptionTips/useTiersModuleCounts';

import s from './MobileContent.scss';

const TOTAL_SWIPEABLE_PANELS = 3;

const MobileContent: React.FC<SubscriptionCenterProps> = ({
  moduleId,
  className,
  stats,
  chartData = [],
}) => {
  const [currentPanel, setCurrentPanel] = useState(1);
  const { draftCount, publishedCount, subscriberCount } =
    useTiersModuleCounts();
  const { ref: swipeRef, onMouseDown } = useSwipeable({
    onSwipedLeft: () =>
      setCurrentPanel(Math.min(TOTAL_SWIPEABLE_PANELS, currentPanel + 1)),
    onSwipedRight: () => setCurrentPanel(Math.max(1, currentPanel - 1)),
  });

  const viewPortTranslateX =
    currentPanel > 1 ? `-${(currentPanel - 1) * 100}%` : `0%`;

  return (
    <div className={cn(s['root'], className)}>
      <div className={s['viewport']}>
        <div
          className={s['swipeable']}
          ref={swipeRef}
          onMouseDown={onMouseDown}
          style={{ transform: `translateX(${viewPortTranslateX})` }}
        >
          <IncomeChartPanel
            className={s['panel']}
            chart={chartData}
            stats={stats && stats[0]}
          />
          <SubscribersChartPanel
            className={s['panel']}
            chart={chartData}
            stats={stats && stats[0]}
          />
          <SubscriptionTips
            moduleId={moduleId}
            className={s['panel']}
            draftCount={draftCount}
            publishedCount={publishedCount}
            subscriberCount={subscriberCount}
          />
        </div>
      </div>
      <Dots
        className={s['pagination']}
        total={TOTAL_SWIPEABLE_PANELS}
        current={currentPanel}
        onClick={n => setCurrentPanel(n)}
      />
    </div>
  );
};
MobileContent.displayName = 'MobileContent';

export default MobileContent;
